import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const StageSportsFilter = ({
    stageSports = [],
    loading,
    filters,
    restoreFilterValues,
    onChangeValue = () => {},
    hidden = false,
}) => (
    <Field
        component={Form.ReduxSelect}
        name='sports'
        hidden={hidden}
        options={stageSports}
        disabled={loading}
        placeholder='Sport'
        loading={loading}
        setValue={restoreFilterValues(filters, 'sports')}
        multiple
        selection
        search
        onChangeValue={onChangeValue}
    />
);

StageSportsFilter.propTypes = {
    stageSports: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
    onChangeValue: PropTypes.func,
    hidden: PropTypes.bool,
};
